import React from 'react';
import '../../../css/login.css';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

class ResetPasswordConfirmation extends React.Component {

    render() {
        const {title, message} = this.props;
        return (
          <div className="reset-password-confirmation-box">
              <div className="checkmark" />
              <div className="informative-title">{title}</div>
              <div className="check-the-email-for">{message}</div>
          </div>
        );
    }
}

ResetPasswordConfirmation.promptTypes = {
    title: PropTypes.string,
    message: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        title: state.login.challengeResponse.title,
        message: state.login.challengeResponse.prompts.message.value
    };
};

export default connect(mapStateToProps)(ResetPasswordConfirmation);
